import styled from 'styled-components'

export const Container = styled.div<{ invert: boolean }>`
  max-width: 1170px;

  display: flex;
  flex-direction: ${({ invert }) => (invert ? 'row-reverse' : 'row')};
  gap: 48px;

  .slide {
    opacity: 0;
    transition: all 0.5s;
    transform: ${(props) =>
      props.invert
        ? 'translateX(-30%) scale(0.95)'
        : 'translateX(30%) scale(0.95)'};

    &.active {
      opacity: 1;
      transform: translateX(0%) scale(1);
    }
  }
  @media (max-width: 791px) {
    flex-direction: ${({ invert }) => (invert ? 'column-reverse' : 'column')};
  }

  @media (max-height: 750px) {
    padding: 0 16px;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;

  .group-text {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .description {
      margin-top: 24px;
    }
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  flex: 1;
`

export const SlideInContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 560px;

  img {
    object-fit: cover;
  }

  @media (max-height: 750px) {
    min-height: auto;
    width: 80%;
  }
  @media (max-width: 500px) {
    min-height: 220px;
    width: 100%;
  }
`
